const yearKey = 'selectYear'

// 获取选择时间
export function getYear() {
    let data = sessionStorage.getItem(yearKey)
    return data ? Number(data) : new Date().getFullYear() - 1
}

// 设置选择时间
export function setYear(year) {
    return sessionStorage.setItem(yearKey, year)
}
